import { useQuery as useQueryParams, useParams as useRouteParams } from '../../../../contexts/RouterContext';
import { omitClientOnlySnippetParams, type SnippetsRouteParams } from '../../../../hooks/api/snippets/shared';
import useSnippets from '../../../../hooks/api/snippets/useSnippets';
import type { SnippetsQueryParams } from '../../../../../shared/snippets';
import type { UseSnippetsOptions } from '../../../../hooks/api/snippets/useSnippets';

/**
 * useSnippetsByUrl is a hook that fetches snippets. It pulls any necessary query
 * information from the current URL.
 */
export default function useSnippetsByUrl() {
  const routeParams = useRouteParams<SnippetsRouteParams>();
  const userRevisionLocator = `${routeParams.project_id}$${routeParams.revision_id}`;

  const [queryParams] = useQueryParams<SnippetsQueryParams>();

  const options: UseSnippetsOptions = {
    userRevisionLocator,
    params: omitClientOnlySnippetParams({ ...queryParams, path: queryParams.path ?? '/' }),
  };

  if (queryParams.olderRevisionLocator && routeParams.status) {
    options.compare = {
      olderRevisionLocator: queryParams.olderRevisionLocator,
      status: routeParams.status,
    };
  }

  return useSnippets(options);
}
